/**
 * Subscription Gate Component.
 * This component acts as the main gate for the application.
 * Users must have an active subscription to access the app.
 */

import React, { useEffect } from 'react';
import {
  useSubscriptionStore,
  useSubscriptionStatus,
  useSubscriptionLoading,
} from '../stores/subscriptionStore';
import { PremiumPage } from './PremiumPage';
import { AppSkeleton } from './AppSkeleton';

interface SubscriptionGateProps {
  children: React.ReactNode;
}

export const SubscriptionGate: React.FC<SubscriptionGateProps> = ({ children }) => {
  const { fetchSubscription } = useSubscriptionStore();
  const { isActive } = useSubscriptionStatus();
  const isLoading = useSubscriptionLoading();

  useEffect(() => {
    fetchSubscription();
  }, [fetchSubscription]);

  if (isLoading) {
    return <AppSkeleton />;
  }

  if (!isActive) {
    return <PremiumPage />;
  }

  // User has active subscription, render the app
  return <>{children}</>;
};

export default SubscriptionGate;
